import React from 'react';
import { Link } from 'react-router-dom';
import './RecipeCard.css';

export default function RecipeCard({ recipe }) {
  const mainImage = recipe.images?.[recipe.mainImageId] || recipe.images?.[0];
  const creator = recipe.createdBy;

  return (
    <Link to={`/recipe/${recipe._id}`} className="recipe-card card fade-in">
      <div className="recipe-card-image">
        {mainImage?.imageURL ? (
          <img src={mainImage.imageURL} alt={recipe.name} loading="lazy" />
        ) : (
          <div className="recipe-card-placeholder">🍽️</div>
        )}
      </div>
      <div className="recipe-card-body">
        <div className="recipe-card-header">
          <h3 className="recipe-card-title">{recipe.name}</h3>
          {recipe.ratingCount > 0 && (
            <div className="recipe-card-rating">
              <span className="recipe-card-star">★</span>
              <span className="recipe-card-score">{recipe.ratingAvg.toFixed(1)}</span>
              <span className="recipe-card-votes">({recipe.ratingCount})</span>
            </div>
          )}
        </div>
        <p className="recipe-card-desc">{recipe.description}</p>
        <div className="recipe-card-meta">
          {creator && (
            <div className="recipe-card-author">
              <div className="author-avatar-sm">
                {creator.profilePicture ? (
                  <img src={creator.profilePicture} alt={creator.username} />
                ) : (
                  <span>{creator.username?.[0]?.toUpperCase()}</span>
                )}
              </div>
              <span>{creator.username}</span>
            </div>
          )}
          <div className="recipe-card-tags">
            {recipe.categories?.slice(0, 2).map(c => (
              <span key={c} className="badge badge-orange">{c}</span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}
